<template>
  <b-card
    :class="{ mainCard: !programmingMode, programmingCard: programmingMode }"
    bg-variant="light"
  >
    <Form @changeToProgrammingMode="changeToProgrammingMode" />
  </b-card>
</template>

<script>
import Form from "@/components/Form.vue";

export default {
  data() {
    return {
      programmingMode: false,
    };
  },
  components: {
    Form,
  },
  methods: {
    changeToProgrammingMode() {
      this.programmingMode = true;
    },
  },
};
</script>
